/*
 *  AbstractFirebaseController__Coupons.js
 *
 *
 *
 */
//==============================================================================
// External dependencies
//==============================================================================
const moment = require("moment");

const COUPONS_COLLECTION = "coupons";

const populateSnapshots = (snapshots) => {
  const docs = [];
  snapshots.forEach((snap) => {
    docs.push(extractSnapshotData(snap));
  });
  return docs;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

//==============================================================================
// Module
//==============================================================================
function CouponsMixin(firebase) {
  return {
    async findActiveCouponWithCode(couponCode) {
      const now = moment().toISOString();

      // Not active though, as we still need to check the startDate
      const couponsNotExpired = await this.collection(COUPONS_COLLECTION)
        .where("code", "==", couponCode)
        .where("isEnabled", "==", true)
        .where("endDate", ">", now)
        // Firebase does not allow inequality filters on multiple properties
        // .where("startDate", "<", now)
        .get()
        .then(populateSnapshots);

      const activeCoupons = couponsNotExpired.filter((c) => c.startDate < now);

      if (activeCoupons.length > 1) {
        return new Error("There are more than 1 active coupons with the same code");
      }

      // Can be undefined
      return activeCoupons[0];
    },
    async findCouponWithId(couponId) {
      return await this.collection(COUPONS_COLLECTION)
        .doc(couponId)
        .get()
        .then(extractSnapshotData);
    },
    async fetchAllCoupons() {
      return await this.collection(COUPONS_COLLECTION).get().then(populateSnapshots);
    },
    async createCoupon(data) {
      const createdDateServerTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      data.createdDate = createdDateServerTimestamp;
      const ref = await this.collection(COUPONS_COLLECTION).add(data);
      const coupon = {
        id: ref.id,
        ...data
      };
      return coupon;
    },
    async updateCoupon(couponId, couponData) {
      const createdDateServerTimestamp = firebase.firestore.FieldValue.serverTimestamp();
      couponData.updatedDate = createdDateServerTimestamp;
      return await this.collection(COUPONS_COLLECTION)
        .doc(couponId)
        .set(couponData, { merge: true });
    }
  };
}

module.exports = CouponsMixin;
